<template>

    <div v-if="enquiry!=null">
        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{enquiry.id}}</a>

                </li>


            </ul>

            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">





                <li class="nav-item bg-white" v-if="enquiry.is_hot==1">
                    <a class="nav-link text-danger"  href="#" role="button"><img style="height: 20px;" src="/images/hot.png"/> &nbsp;Hot Lead</a>

                </li>

                <li class="nav-item ml-2" v-bind:class="{ 'bg-warning': enquiry.status=='Pending' ,'bg-red':enquiry.status=='Closed','bg-success':enquiry.status=='Convered','bg-info':enquiry.status=='InProgress'}">
                    <a class="nav-link"  href="#" role="button">{{enquiry.status}}</a>

                </li>
                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+enquiry.encryptedid" role="button">BACK</a>
                </li>


            </ul>
        </nav>
        <section class="content pt-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER DETAIL
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="lead"><b>{{enquiry.name}}</b></h2>
                                            <ul class="ml-4 mb-0 fa-ul text-muted">

                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone : {{enquiry.mobile}}</li>
                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-envelope"></i></span> Email : {{enquiry.email_id}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER REQUIREMENT
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted"> Duration</li>
                                                <li class="small" v-if="enquiry.nights>0"> {{enquiry.nights}} Nights {{enquiry.nights+1}} Days</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Starting Date</li>
                                                <li class="small"> {{enquiry.departure_date}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Destination</li>
                                                <li class="small">{{enquiry.destinations}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Source</li>
                                                <li class="small">{{enquiry.source}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Budget</li>
                                                <li class="small">  {{enquiry.budget}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">No. of Travelers</li>
                                                <li class="small">  Adults -  {{enquiry.adults}} </li>
                                                <li class="small">  Childs - {{enquiry.childs}} </li>
                                                <li class="small">  Infants - {{enquiry.infants}} </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Specific Requirements</li>
                                                <li class="small">
                                                    <specific-requirements-display :text="enquiry.specific_requirements"></specific-requirements-display>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-9">
                        <div class="col-12">
                            <el-card class="mini-box-card  box-d-card" >

                                <el-tabs type="border-card" class="qtn-tabs">
                                    <el-tab-pane  v-for="quotation in quotations" :key="quotation.id">
                                        <template #label>
                                            <div class="qnt-list-box">
                                                <p class="price">Rs.  {{quotation.quote_price}} <small >Total</small> </p>
                                               </div>


                                        </template>


                                        <div >
                                            <el-row>
                                                <el-col>
                                                    <a :href="'/enquiry/newquote/create?enqid='+enquiry.encryptedid+'&bqid='+quotation.encryptedid" >

                                                        <el-button type="primary" size="small" >Use Quote</el-button>
                                                    </a>

                                                    <a target="_blank" :href="'/quotations/'+quotation.encryptedid" >
                                                        <el-button type="primary" size="small" class="ml-2">View Quote</el-button>
                                                    </a>


                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col class="mt-2">
                                                    <el-descriptions
                                                        class="margin-top"
                                                        :column="3"
                                                        border
                                                        direction="vertical"
                                                    >

                                                        <el-descriptions-item>
                                                            <template #label>
                                                                <div class="cell-item">
                                                                    Nights/Days
                                                                </div>
                                                            </template>
                                                            {{quotation.nights}}Nights & {{quotation.nights+1}}Days
                                                        </el-descriptions-item>
                                                        <el-descriptions-item>
                                                            <template #label>
                                                                <div class="cell-item">
                                                                    Quotation Price
                                                                </div>
                                                            </template>
                                                            Rs. {{quotation.quote_price}} <small>Total</small>
                                                        </el-descriptions-item>
                                                        <el-descriptions-item>
                                                            <template #label>
                                                                <div class="cell-item">
                                                                    Destination
                                                                </div>
                                                            </template>
                                                            <span v-for="destination in quotation.destinations">{{destination}}</span>
                                                        </el-descriptions-item>
                                                    </el-descriptions>
                                                </el-col>
                                                <el-col class="mt-2" v-if="quotation.hotel_includes==1">
                                                    <el-card >
                                                        <h5>Hotels</h5>
                                                        <p v-for="hotel in quotation.hotels">
                                                            CheckIn- {{ hotel.data.checkIn}}, CheckOut- {{ hotel.data.checkOut}}, {{ hotel.data.name}}, {{ hotel.data.city}}, {{ hotel.data.rating}} Star, {{ hotel.data.type}}
                                                            <h6>Rooms</h6>
                                                            <p v-for="room in hotel.data.rooms">
                                                                {{ room.type }}, for {{ room.adt }} A  <span v-if="room.chd>0"> - {{ room.chd }} C</span> , {{ Array.isArray(room.mb) ? room.mb.join(', ') : room.mb }}
                                                            </p>

                                                        </p>
                                                    </el-card>
                                                </el-col>

                                            </el-row>
                                            <el-card v-if="quotation.inclusions.length>0 || quotation.exclusions.length>0" class="mt-2">
                                                <el-row >
                                                    <el-col :span="12">

                                                        <h5>Inclusions</h5>
                                                        <ul>
                                                            <li v-for="inclusion in quotation.inclusions">{{inclusion}}</li>
                                                        </ul>

                                                    </el-col>
                                                    <el-col :span="12">

                                                        <h5>Exclusions</h5>
                                                        <ul>
                                                            <li v-for="exclusion in quotation.exclusions">{{exclusion}}</li>
                                                        </ul>


                                                    </el-col>
                                                </el-row>
                                            </el-card>
                                            <el-collapse class="mt-2"  accordion>
                                                <el-collapse-item v-for="daytn in quotation.itenaries" :title="'Day '+daytn.day+' : '+daytn.title" :name="daytn.day">
                                                    <p>
                                                        {{daytn.description}}
                                                    </p>
                                                </el-collapse-item>
                                            </el-collapse>

                                        </div>
                                    </el-tab-pane>

                                </el-tabs>

                            </el-card>

                        </div>
                    </div>
                </div>
            </div>
        </section>



    </div>





</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import FlightComboDetailsCard from "./Flight/Components/FlightComboDetailsCard.vue";
import SpecificRequirementsDisplay from "../Enquiry/Components/SpecificRequirementsDisplay.vue";
export default {
    name: "BestMatchingQuotation",
    components: {FlightComboDetailsCard, SpecificRequirementsDisplay},
    props:['id'],
    data() {
        return {
            loading:false,
            enquiry:null,
            quotations:null,
    }
    },
    mounted() {

        this.getdetails();

    },
    methods: {


        getdetails() {

            let currentObj = this;
            axios.get('/enquirydetails?id='+this.id).then(function (response) {
                currentObj.enquiry=response.data.enquiry;
    })
                .catch(function (error) {
                });


            axios.get('/enquiry/newquote/getbestmatchingquotes?id='+this.id).then(function (response) {
                currentObj.quotations=response.data;


            })
                .catch(function (error) {
                });
        }

    }
}
</script>

<style scoped>

</style>
